import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import { AppVariation } from "src/client-config/getClientConfig.ts";
import type { Module } from "src/system/module.types.ts";
import type { OwnerProfileResource } from "@exonn/js-sdk";

export const module: Module<OwnerProfileResource> = {
  id: ResourceEnum.OwnerProfile,
  bigIcon: <span className={"icon-20-custmr_prfl"} />,
  smallIcon: <span className={"icon-15-custmr_prfl"} />,
  name: (t: TFunction) => t("moduleName.owners-profile"),
  disableDelete: ({ clientConfig }) =>
    clientConfig.appVariation === AppVariation.B2bGateSupplier,
  disableCreate: ({ clientConfig }) =>
    clientConfig.appVariation === AppVariation.B2bGateSupplier,

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
